// https://date-fns.org/docs/parse
import parseDate from 'date-fns/parse'
// https://date-fns.org/docs/format
import format from 'date-fns/format'

import lunarCalendar from './lunar-calendar'

export default function formatDate(date, pattern = 'date') {
  if (!date) return
  date = parseDate(date)
  const patternMap = {
    date: 'YYYY/MM/DD',
    'date-dash': 'YYYY-MM-DD',
    dateTime: 'YYYY/MM/DD HH:mm',
    dateWeekDay: 'YYYY/MM/DD (ddd)',
    time: 'HH:mm',
  }
  return format(date, patternMap[pattern])
}

export function formatDateRange(startDate, endDate) {
  return `${formatDate(startDate) || '無開始日期'} ～ ${formatDate(endDate) || '無結束日期'}`
}

export function formatTimeRange(startTime, endTime) {
  return `${startTime}～${endTime}`
}

export function formatDateTimeRange(startDate, endDate, startTime, endTime) {
  const startDateTime = `${formatDate(startDate)} ${startTime}`
  const endDateTime = `${formatDate(endDate)} ${endTime}`
  return startDate === endDate ? (startTime && endTime ? `${startDateTime}～${endTime}` : formatDate(startDate)) : `${startDateTime}～${endDateTime}`
}

export function formatRequestData(date, pattern = 'date') {
  if (!date) return
  date = parseDate(date)
  const patternMap = {
    date: 'YYYY-MM-DD',
    time: 'HH:mm',
  }
  return format(date, patternMap[pattern])
}

export function solarToLunar(date) {
  if (!date) return
  if (date instanceof Object) date = format(date, 'YYYY-MM-DD')
  date = date.split(' ')[0].replace(/\//g, '-')
  return lunarCalendar.solar2lunar(...date.split('-'))
}

export function lunarToSolar(date) {
  if (!date) return
  if (date instanceof Object) date = format(date, 'YYYY-MM-DD')
  date = date.split(' ')[0].replace(/\//g, '-')
  return lunarCalendar.lunar2solar(...date.split('-'))
}

export function toLunarTime(time) {
  const lunarTime = ['子', '丑', '丑', '寅', '寅', '卯', '卯', '辰', '辰', '巳', '巳', '午', '午', '未', '未', '申', '申', '酉', '酉', '戌', '戌', '亥', '亥', '子']
  return lunarTime[parseInt(time.split(':')[0])]
}

export function lunarDateTime(date, time) {
  if (!date) return '請選擇日期'
  const lunarDate = solarToLunar(date)
  const lunarTime = !time ? '' : toLunarTime(time) + '時'

  return `${lunarDate.gzYear} 肖${lunarDate.Animal} ${lunarDate.IMonthCn}${lunarDate.IDayCn} ${lunarTime}`
}

export function formatLunarDate(date) {
  const lunarDate = solarToLunar(date)
  return `${lunarDate.cYear}${lunarDate.gzYear}肖${lunarDate.Animal}(民國${lunarDate.cYear - 1911}年)`
}
